import axios from 'axios';
import * as actionType from '../actionTypes';
import apiConstants from '../../constans/apiConstants';
import { toaster } from "../../utils/utils";

export const getSmsEmailLogs = (pgNo, maxRec) => {
    let apiUrl = '';

    apiUrl = `${apiConstants().BAXA_API_URL}ccmSmsEmailLogs?pageNumber=${pgNo}&maxRecords=${maxRec}`;

    return dispatch => {
        dispatch({ type: actionType.LOADER_TRUE });
        axios.get(apiUrl, {
            headers: {
                "Content-Type": "application/json",
                authorization: localStorage.getItem("token"),
            }
        }).then((res) => {
            dispatch({ type: actionType.LOADER_FALSE })
            if (res.data.body) {
                dispatch({
                    type: actionType.SMS_EMAIL_LOGS,
                    smsEmaildata: res.data.body
                })
                toaster("success", res.data.message)
            } else {
                toaster("error", res.data.message)
            }
        }).catch(() => {
            dispatch({ type: actionType.LOADER_FALSE })
            dispatch({
                type: actionType.SMS_EMAIL_LOGS,
                smsEmaildata: []
            })
        })
    }
}





